import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { generateDependentTableFilters } from '@/main/utils/dependentTablesGenerator';
import { FakturacniProfil } from '@/modules/ciselnik/zakaznicke/zakaznickaSkupina/fakturacniProfil';
import { NahradniSazbaPujcovna } from '@/modules/ciselnik/zakaznicke/zakaznickaSkupina/nahradniSazbaPujcovna';

import { NAME as name, CRUMB_LABEL_KEY, InternMatFirmEnum } from '../constants';
import { apiProvider } from '../api';
import { DEPENDENT_TABLES as depTableNames } from './types';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		NoraPzn: [],
		InternMatFirm: [],
	},
	depTableNames,
	depTableSettings: {
		[FakturacniProfil.name]: { filter(state) { return { ZakaznikSk: state.edit.ZakaznikSk }; } },
		[NahradniSazbaPujcovna.name]: { filter(state) { return { ZakaznikSk: state.edit.ZakaznikSk }; } },
	},
	edit: {
		EditDat: null as Date | null,
		EditPracId: null as number | null,
		InterniSkPrp: null as boolean | null,
		MatfirmPrp: null as boolean | null,
		NoraPzn: null as number | null,
		PnvZmenPrp: null as boolean | null,
		PreshrprodPrp: null as boolean | null,
		RekltxtId: null as number | null,
		SlevaNv: null as number | null,
		SlevaOv: null as number | null,
		Text: null as string | null,
		Text2DdNv: null as string | null,
		Text2DdOv: null as string | null,
		VelkoodbPrp: null as boolean | null,
		VstupDat: null as Date | null,
		VstupPracId: null as number | null,
		VyrazenDat: null as Date | null,
		ZakaznikSk: null as number | null,
		ZamestnanPrp: null as boolean | null,
		ZaznamId: null as number | null,
		InternMatFirm: null as InternMatFirmEnum | null,
	},
	localState: {},
	props: {
		mode: null,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
});
